import React from 'react';
import { Box } from '@mui/joy';
import { YextListingsCard } from './YextListingsCard';
import { useAuth } from '../../contexts/AuthContext';

export const CitationsTable: React.FC = () => {
  const { user } = useAuth();
  const isAdmin = user?.is_organization_admin || false;

  return (
    <Box>
      {/* Yext Listings Section - Admin Only */}
      <YextListingsCard isAdmin={isAdmin} />
    </Box>
  );
};
